<template>
  <section class="news container">
    <h2>{{ $t("home.news_title") }}</h2>

    <div class="news-list">
      <div
        v-for="n in newsList"
        :key="n.id"
        class="news-item"
        @click="goDetail(n.url)"
      >
        <div class="news-left">
          <img :src="getImgUrl(n.img)" alt="news" />
        </div>
        <div class="news-right">
          <h3>{{ n.title }}</h3>
          <p class="meta">{{ n.date }}</p>
          <p class="summary clamp">{{ n.summary }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CompanyNews",
  computed: {
    newsList() {
      // 自动从 i18n 文件中读取中英文新闻数据
      console.log(this.$t("home.news"))
      return this.$t("home.news");
    },
  },
  methods: {
    getImgUrl(path) {
      try {
        console.log(path)
        return require(`@/assets/${path.replace("/assets/", "")}`);
      } catch (e) {
        return "";
      }
    },

    goDetail(link) {
      if (link) window.open(link, "_blank");
    },
  },
};
</script>

<style scoped>
.news {
  max-width: 1200px;
}

.news h2 {
  text-align: left;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* 列表布局 */
.news-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.news-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.25s ease;
}

.news-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}

/* 左侧图片 */
.news-left img {
  width: 160px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}

/* 右侧文字 */
.news-right {
  flex: 1;
}

.news-right h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 4px;
}

.meta {
  font-size: 14px;
  color: #999;
  margin-bottom: 6px;
}

/* 文本省略 */
.summary {
  font-size: 15px;
  color: #555;
  line-height: 1.5;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式（移动端） */
@media (max-width: 768px) {
  .news-item {
    flex-direction: column;
  }

  .news-left img {
    width: 100%;
    height: 180px;
  }
}
</style>
